(function() {
  'use strict';

  var STORAGE_KEY = 'th_cookie_consent';
  var STORAGE_VERSION = 1;

  var banner = document.getElementById('th-cookie-banner');
  var reopenBtn = document.getElementById('th-cookie-reopen');
  if (!banner) return;

  var viewMain = banner.querySelector('[data-cookie-view="main"]');
  var viewPrefs = banner.querySelector('[data-cookie-view="prefs"]');
  var analyticsToggle = banner.querySelector('[data-cookie-pref="analytics"]');
  var marketingToggle = banner.querySelector('[data-cookie-pref="marketing"]');

  function getStoredConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (data.v !== STORAGE_VERSION) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function saveConsent(prefs) {
    var data = {
      v: STORAGE_VERSION,
      analytics: !!prefs.analytics,
      marketing: !!prefs.marketing,
      timestamp: Date.now()
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
    applyShopifyConsent(data);
  }

  function applyShopifyConsent(prefs) {
    function setIt() {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!prefs.analytics,
          marketing: !!prefs.marketing,
          preferences: !!prefs.analytics,
          sale_of_data: false
        }, function() {});
      }
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err) {
        if (!err) setIt();
      });
    } else {
      setIt();
    }
  }

  function showView(name) {
    if (name === 'prefs') {
      viewMain.hidden = true;
      viewPrefs.hidden = false;
    } else {
      viewMain.hidden = false;
      viewPrefs.hidden = true;
    }
  }

  function openBanner() {
    showView('main');
    var existing = getStoredConsent();
    if (existing) {
      analyticsToggle.checked = !!existing.analytics;
      marketingToggle.checked = !!existing.marketing;
    }
    banner.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function() {
      banner.classList.add('is-visible');
    });
    if (reopenBtn) reopenBtn.hidden = true;
  }

  function closeBanner() {
    banner.classList.remove('is-visible');
    banner.setAttribute('aria-hidden', 'true');
    if (reopenBtn) reopenBtn.hidden = false;
  }

  function handleClick(e) {
    var trigger = e.target.closest('[data-cookie-action]');
    if (!trigger) return;
    var action = trigger.getAttribute('data-cookie-action');

    if (action === 'accept-all') {
      saveConsent({ analytics: true, marketing: true });
      closeBanner();
    } else if (action === 'reject-all') {
      saveConsent({ analytics: false, marketing: false });
      closeBanner();
    } else if (action === 'show-prefs') {
      showView('prefs');
    } else if (action === 'back') {
      showView('main');
    } else if (action === 'save-prefs') {
      saveConsent({
        analytics: analyticsToggle.checked,
        marketing: marketingToggle.checked
      });
      closeBanner();
    }
  }

  banner.addEventListener('click', handleClick);

  if (reopenBtn) {
    reopenBtn.addEventListener('click', function() {
      openBanner();
    });
  }

  // Init
  var stored = getStoredConsent();
  if (!stored) {
    setTimeout(openBanner, 600);
  } else {
    applyShopifyConsent(stored);
    if (reopenBtn) reopenBtn.hidden = false;
  }

  // Footer linki / test için: THCookies.open() veya THCookies.reset()
  window.THCookies = {
    open: openBanner,
    reset: function() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      openBanner();
    }
  };
})();